
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/lib/supabase";
import { KarmaActivity } from "../types/karma-types";
import { KarmaClaimConfigDetails } from "../utils/karmaClaimConfig";

export const useKarmaActivity = (
  setActivities: React.Dispatch<React.SetStateAction<KarmaActivity[]>>
) => {
  const { user } = useAuth();

  const createKarmaActivityRecord = async (
    claimDetails: KarmaClaimConfigDetails
  ): Promise<void> => {
    if (!user) return;

    const activityData = {
      user_id: user.id,
      title: claimDetails.title,
      points: claimDetails.points,
      activity_type: claimDetails.activityType,
      description: claimDetails.description,
    };

    try {
      const { data: activityRecord, error } = await supabase
        .from('karma_activities')
        .insert(activityData)
        .select()
        .single();
        
      if (error) throw error;
        
      if (activityRecord) {
        setActivities(prev => [activityRecord as KarmaActivity, ...prev]);
      } else {
        // Fallback for safety, though select().single() should return data or error
        const newActivity: KarmaActivity = {
          id: crypto.randomUUID(),
          ...activityData,
          created_at: new Date().toISOString(),
        };
        setActivities(prev => [newActivity, ...prev]);
      }
    } catch (error) {
      console.error("Error creating karma activity, using local state:", error);
      const newActivity: KarmaActivity = {
        id: crypto.randomUUID(),
        ...activityData,
        created_at: new Date().toISOString(),
      };
      setActivities(prev => [newActivity, ...prev]);
    }
  };

  return { createKarmaActivityRecord };
};

